import { Box, InputLabel } from '@mui/material';
import { Field, useField, useFormikContext } from 'formik';
import React from 'react';

interface Props {
	type?: 'text' | 'tel' | 'password' | 'number' | 'search' | 'color';
	placeholder?: string;
	name: string;
	useFormik?: boolean;
	setFieldValue?: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
	readonly?: boolean;
	disabled?: boolean;
	label?: string;
	maxLength?: number;
	step?: number;
	min?: number;
	max?: number;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const Textfield: React.FC<Props> = ({
	type,
	placeholder,
	name,
	useFormik,
	readonly,
	disabled,
	label,
	onBlur,
	...props
}) => {
	const [field] = useField({ name });
	const { setFieldValue } = useFormikContext();

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		if (type === 'number') {
			let val = Number(e.target.value);
			if (props.min !== undefined && val < props.min) val = props.min;
			if (props.max !== undefined && val > props.max) val = props.max;
			setFieldValue(name, val);
		}
		if (onBlur) onBlur(e);
	};

	return (
		<Box sx={{}} className="a-textfield_input">
			{label && <InputLabel sx={{ marginBottom: 1 }}>{label}</InputLabel>}
			<Field
				style={{
					width: '100%',
					padding: '10px 15px',
					border: '1px solid #D0D5DD',
					borderRadius: '8px',
					background: disabled ? 'rgba(0, 0, 0, 0.12)' : '',
				}}
				type={type}
				placeholder={placeholder}
				name={name}
				readOnly={readonly}
				disabled={disabled}
				{...props}
				onBlur={handleBlur}
			/>
			{props?.maxLength && (
				<Box mt={1} color="#475467" fontSize="14px">{`${field.value?.length || 0}/${props.maxLength}`}</Box>
			)}
		</Box>
	);
};

export const FieldFormik: React.FC<Props> = props => {
	const { setFieldValue } = useFormikContext();
	return <Textfield {...props} setFieldValue={setFieldValue} useFormik />;
};

export default FieldFormik;
